import { invoiceActionStatus } from "@/lib/utils";
import { setInvoiceDueDate, setVendors } from "@/redux/slices";
import { RootState } from "@/redux/store";
import { getOwnerBomBase, routes } from "@/routes/utils";
import {
  useGetExpenseIncomePerformance,
  useGetOpenIncidentDashboardCount,
  useGetOwnerDashboardParkedStatus,
} from "@/services";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const useCriticalActionSection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const base = getOwnerBomBase(useLocation().pathname);
  const { communityData, currentFinanceYear } = useSelector(
    (state: RootState) => state.currentData
  );

  const { data: parkedStatus, isLoading: isParkedStatus } =
    useGetOwnerDashboardParkedStatus({
      communityId: communityData?.communityId,
      year: currentFinanceYear,
      queryParams: {
        enabled: !!(communityData?.communityId && currentFinanceYear),
      },
    });

  const { data: openIncident, isLoading: isOpenIncidentLoading } =
    useGetOpenIncidentDashboardCount({
      communityId: communityData?.communityId,
      year: currentFinanceYear,
      // userId: loggedInUserData?.userId, 
      queryParams: {
        enabled: !!(communityData?.communityId && currentFinanceYear),
      },
    });

  const { data: expenseIncomeData, isLoading: isExpenseIncomeDataLoading } =
    useGetExpenseIncomePerformance({
      communityId: communityData?.communityId,
      year: currentFinanceYear,
      queryParams: {
        enabled: !!(communityData?.communityId && currentFinanceYear),
      },
    });

  const onInvoiceAwaitingClick = () => {
    navigate(
      `${routes.invoice}/${invoiceActionStatus.pending_for_my_approval}`
    );
  };
  const onViewIncident = () => {
    navigate(`/${base}/${routes.incidentMgmt}`);
  };

  const onOverdueClick = () => {
    dispatch(setVendors(null));
    dispatch(setInvoiceDueDate("overdue"));
    navigate(`${routes.invoice}/${invoiceActionStatus.posted}`);
  };
  
  const overdueCount = useMemo(() => expenseIncomeData?.data?.totalOverdueCount || 0, [expenseIncomeData])
  const awaitingApproval = useMemo(() => parkedStatus?.data?.pendingApprovalCounts, [parkedStatus])
  const incidentCount = useMemo(() => 
    openIncident?.data
      ?.filter(
        (item: any) =>
          item.label?.toLowerCase() !== "longest open"
      )
      .reduce((sum: number, item: any) => sum + item.days,0) || 0,
  [openIncident]);

  return {
    onInvoiceAwaitingClick,
    parkedStatus,
    isParkedStatus,
    isOpenIncidentLoading,
    openIncident,
    onViewIncident,
    onOverdueClick,
    isExpenseIncomeDataLoading,
    expenseIncomeData,
    awaitingApproval,
    incidentCount,
    overdueCount
  };
};

export default useCriticalActionSection;
